import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialogComponent } from "../../../shared/dialogs/confirm-dialog/confirm-dialog.component";
import { TestResult } from "../../../shared/models/classes/Dashboard/test-result";
import { IsTestLaunched } from "../../../shared/models/classes/IsTestLaunched/is-test-launched";
import { ProviderCode } from "../../../shared/models/enums/provider-code.enum";
import { DashboardBizzDevService } from "../../../shared/services/dashboard-bizz-dev.service";

@Component({
    selector: "app-test-comparison",
    templateUrl: "./test-comparison.component.html",
    styleUrls: ["./test-comparison.component.scss"],
})
export class TestComparisonComponent implements OnInit {
    testResult: TestResult;
    lastTestDate: Date = null;
    isTestLaunched: IsTestLaunched;
    isRunningDisplay: string;
    providerType: any;

    constructor(
        private dashboardService: DashboardBizzDevService,
        private formBuilder: FormBuilder,
        private dialog: MatDialog
    ) {}
    providerForm: FormGroup = this.formBuilder.group({
        provType: ["", Validators.required],
    });

    ngOnInit(): void {
        this.initProviderType();
        this.getTestResults();
        this.getIsTestLaunchedState();
    }
    initProviderType() {
        this.providerType = Object.values(ProviderCode);
    }
    get getFormControls() {
        return this.providerForm.controls;
    }

    launchTest(providerCode: string): void {
        const dlg = this.dialog.open(ConfirmDialogComponent, {
            data: {
                message:
                    "Vous êtes sur le point de lancer la procédure de test.",
            },
        });
        dlg.afterClosed().subscribe((value) => {
            if (value) {
                this.executeTestMethod(providerCode);
            }
        });
    }
    executeTestMethod(providerCode: string) {
        this.dashboardService.launchTest(providerCode).subscribe(() => {
            this.getTestResults();
            this.getIsTestLaunchedState();
        });
    }

    getIsTestLaunchedState(): void {
        this.dashboardService.getIsTestLaunchedState().subscribe((value) => {
            this.isTestLaunched = value;
        });
    }

    getTestResults(): void {
        this.dashboardService
            .getTest()
            .subscribe((value) => (this.testResult = value));
    }
}
